import React from "react";
import { Dropdown } from "@ddm-design-system/dropdown";
import { hoursToMinutes, minutesToHours } from "../../lib/Time/TimeFunctions";

const FIRST_HOUR = 0;
const hours = Array.from(Array(48).keys());
const hourItems = hours.map(_key => {
  const key = (_key + FIRST_HOUR * 2) % hours.length; // sets the first hour to appear on the dropdown
  const hour = Math.floor(key / 2);
  const minutes = key % 2 ? 30 : 0;
  const id = hoursToMinutes(hour, minutes);
  return {
    id: id.toString(),
    text: minutesToHours(id)
  };
});

interface IProps {
  className?: string;
  selectedHour: number;
  onHourSelected: (hour: number) => void;
}

const HourDropdown: React.FC<IProps> = ({ selectedHour, onHourSelected, ...props }) => (
  <Dropdown
    selectedItem={
      selectedHour !== undefined
        ? hourItems.find(i => i.id === selectedHour.toString()) ?? {
            id: selectedHour.toString(),
            text: minutesToHours(selectedHour)
          }
        : undefined
    }
    onItemSelected={item => onHourSelected(parseInt(item.id))}
    items={hourItems}
    {...props}
  />
);

export default HourDropdown;
